import React from "react";
import approvalIQ from "../../assets/images/logos/approval-iq-logo.png";
import ProofMaster from "../../assets/images/logos/proof-master-logo.png";
import MaltiEnt from "../../assets/images/logos/malti-ep-logo.png";
import GolfDazzle from "../../assets/images/logos/golf-dazzle-logo.png";
import CrossFund from "../../assets/images/logos/cross-fund-logo.png";
import ANCSol from "../../assets/images/logos/anc-logo.png";
import TeamTailor from "../../assets/images/logos/team-tailor-logo.png";
import WeddingRaja from "../../assets/images/logos/wedding-raja-logo.png";
import NeelKanth from "../../assets/images/logos/neel-kanth-logo.png";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "../../assets/css/custom-carousel.css";
import { Carousel } from "react-responsive-carousel";

const OurClients = () => {
    const data = [
        {
            img: approvalIQ,
            height: "auto",
            width: "auto",
        },
        {
            img: ProofMaster,
            height: "auto",
            width: "auto",
        },
        {
            img: MaltiEnt,
            height: "64px",
            width: "64px",
        },
        {
            img: GolfDazzle,
            height: "auto",
            width: "auto",
        },
        {
            img: CrossFund,
            height: "auto",
            width: "auto",
        },
        {
            img: ANCSol,
            height: "auto",
            width: "auto",
        },
        {
            img: TeamTailor,
            height: "auto",
            width: "auto",
        },
        {
            img: WeddingRaja,
            height: "auto",
            width: "auto",
        },
        {
            img: NeelKanth,
            height: "auto",
            width: "auto",
        },
        {
            img: GolfDazzle,
            height: "auto",
            width: "auto",
        },
    ];

    return (
        <section className="font-[Montserrat]">
            <div className="bg-background">
                <div className="pt-10 pb-7">
                    {/* <div className="container mx-auto md:px-14 px-8"> */}
                    <div className="text-prime text-center font-semibold text-2xl p-2">
                        Our Clients
                    </div>
                    <div className="text-center text-xl p-5">
                        Trusted by ambitious founders & Businesses around the
                        globe
                    </div>
                    <Carousel
                        showThumbs={false}
                        showArrows={false}
                        showStatus={false}
                        centerMode={true}
                        centerSlidePercentage={25}
                        infiniteLoop={true}
                        emulateTouch={false}
                        autoPlay={true}
                        interval={2500}
                        slidesToShow={2}
                        showIndicators={false}
                    >
                        {data.map((banner, index) => (
                            <div key={index} className="px-8 grayscale">
                                <img
                                    src={banner.img}
                                    alt="img"
                                    style={{
                                        width: `${banner.width}`,
                                        height: `${banner.height}`,
                                    }}
                                />
                            </div>
                        ))}
                    </Carousel>
                    {/* </div> */}
                </div>
            </div>
        </section>
    );
};

export default OurClients;
